export const altGaming = {
  winfinityGaming: {
    AgentSpinity: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Agent Spinity",
      name: "Agent Spinity",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/AgentSpinity.jpg",
      redirectUrl: "/casino/aggapwinfinity-agent-spinity",
    },
    AutoRoulette: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Auto Roulette",
      name: "Auto Roulette",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/AutoRoulette.jpg",
      redirectUrl: "/casino/aggapwinfinity-auto-roulette",
    },
    AutoRoulette500x: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Auto Roulette 500x",
      name: "Auto Roulette 500x",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/AutoRoulette500x.jpg",
      redirectUrl: "/casino/aggapwinfinity-auto-roulette-500x",
    },
    BarBlackjack3: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bar Blackjack 3",
      name: "Bar Blackjack 3",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/BarBlackjack3.jpg",
      redirectUrl: "/casino/aggapwinfinity-bar-blackjack-3",
    },
    BarBlackjack4: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bar Blackjack 4",
      name: "Bar Blackjack 4",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/BarBlackjack4.jpg",
      redirectUrl: "/casino/aggapwinfinity-bar-blackjack-4",
    },
    BarBlackjack5: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bar Blackjack 5",
      name: "Bar Blackjack 5",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/BarBlackjack5.jpg",
      redirectUrl: "/casino/aggapwinfinity-bar-blackjack-5",
    },
    BarRoulette2000x: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bar Roulette 2000x",
      name: "Bar Roulette 2000x",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/BarRoulette2000x.jpg",
      redirectUrl: "/casino/aggapwinfinity-bar-roulette-2000x",
    },
    BigBangRoulette: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "BigBang Roulette",
      name: "BigBang Roulette",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/BigBangRoulette.jpg",
      redirectUrl: "/casino/aggapwinfinity-bigbang-roulette",
    },
    CabaretRoulette: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cabaret Roulette",
      name: "Cabaret Roulette",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/CabaretRoulette.jpg",
      redirectUrl: "/casino/aggapwinfinity-cabaret-roulette",
    },
    DragonTiger: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/DragonTiger.jpg",
      redirectUrl: "/casino/aggapwinfinity-dragon-tiger",
    },
    HangukAutoRoulette: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hanguk Auto Roulette",
      name: "Hanguk Auto Roulette",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/HangukAutoRoulette.jpg",
      redirectUrl: "/casino/aggapwinfinity-hanguk-auto-roulette",
    },
    LiveLobby: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Live Lobby",
      name: "Live Lobby",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/LiveLobby.jpg",
      redirectUrl: "/casino/aggapwinfinity-live-lobby",
    },
    ShangrilaBaccarat5: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Shangrila Baccarat 5",
      name: "Shangrila Baccarat 5",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/ShangrilaBaccarat5.jpg",
      redirectUrl: "/casino/aggapwinfinity-shangrila-baccarat-5",
    },
    ShangrilaBaccarat6: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Shangrila Baccarat 6",
      name: "Shangrila Baccarat 6",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/ShangrilaBaccarat6.jpg",
      redirectUrl: "/casino/aggapwinfinity-shangrila-baccarat-6",
    },
    TaoYuanBaccarat1: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tao Yuan Baccarat 1",
      name: "Tao Yuan Baccarat 1",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/TaoYuanBaccarat1.jpg",
      redirectUrl: "/casino/aggapwinfinity-tao-yuan-baccarat-1",
    },
    TaoYuanBaccarat2: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tao Yuan Baccarat 2",
      name: "Tao Yuan Baccarat 2",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/TaoYuanBaccarat2.jpg",
      redirectUrl: "/casino/aggapwinfinity-tao-yuan-baccarat-2",
    },
    TaoYuanBaccarat5: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tao Yuan Baccarat 5",
      name: "Tao Yuan Baccarat 5",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/TaoYuanBaccarat5.jpg",
      redirectUrl: "/casino/aggapwinfinity-tao-yuan-baccarat-5",
    },
    TaoYuanBaccarat6: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tao Yuan Baccarat 6",
      name: "Tao Yuan Baccarat 6",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/TaoYuanBaccarat6.jpg",
      redirectUrl: "/casino/aggapwinfinity-tao-yuan-baccarat-6",
    },
    TaoYuanBaccarat7: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tao Yuan Baccarat 7",
      name: "Tao Yuan Baccarat 7",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/TaoYuanBaccarat7.jpg",
      redirectUrl: "/casino/aggapwinfinity-tao-yuan-baccarat-7",
    },
    TaoYuanBaccarat8: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tao Yuan Baccarat 8",
      name: "Tao Yuan Baccarat 8",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/TaoYuanBaccarat8.jpg",
      redirectUrl: "/casino/aggapwinfinity-tao-yuan-baccarat-8",
    },
    TopCard: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Top Card",
      name: "Top Card",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/TopCard.jpg",
      redirectUrl: "/casino/aggapwinfinity-top-card",
    },
    VeniceBlackjack2: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Venice Blackjack 2",
      name: "Venice Blackjack 2",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/VeniceBlackjack2.jpg",
      redirectUrl: "/casino/aggapwinfinity-venice-blackjack-2",
    },
    VeniceBlackjack4: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Venice Blackjack 4",
      name: "Venice Blackjack 4",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/VeniceBlackjack4.jpg",
      redirectUrl: "/casino/aggapwinfinity-venice-blackjack-4",
    },
    VeniceRoulette: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Venice Roulette",
      name: "Venice Roulette",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/VeniceRoulette.jpg",
      redirectUrl: "/casino/aggapwinfinity-venice-roulette",
    },
    VeniceRoulette: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Venice Roulette",
      name: "Venice Roulette",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/VeniceRoulette.jpg",
      redirectUrl: "/casino/aggapwinfinity-venice-roulette",
    },
    VIPAutoRoulette: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VIP Auto Roulette",
      name: "VIP Auto Roulette",
      providerName: "Winfinity",
      imgUrl: "./images/alt-gaming/Winfinity/VIPAutoRoulette.jpg",
      redirectUrl: "/casino/aggapwinfinity-vip-auto-roulette",
    },
  },
  voltentGaming: {
    BellsEasterJackpots12: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "12 Bells Easter Jackpots",
      name: "12 Bells Easter Jackpots",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/12bellsEasterJackpots.jpg",
      redirectUrl: "/casino/aggapvoltent-12-bells-easter-jackpots",
    },
    CoinsGrandDiamondEditionEasterJackpots21: {
      code: "56768",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "12 Coins Grand Diamond Edition Easter Jackpots",
      name: "12 Coins Grand Diamond Edition Easter Jackpots",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/12CoinsGrandDiamondEditionEasterJackpots.jpg",
      redirectUrl:
        "/casino/aggapvoltent-12-coins-grand-diamond-edition-easter-jackpots",
    },
    CoinsGrandPlatinumEditionEasterJackpots16: {
      code: "98790",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "16 Coins Grand Platinum Edition Easter Jackpots",
      name: "16 Coins Grand Platinum Edition Easter Jackpots",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/16CoinsGrandPlatinumEditionEasterJackpots.jpg",
      redirectUrl:
        "/casino/aggapvoltent-16-coins-grand-platinum-edition-easter-jackpots",
    },
    CoinsGrandPlatinumEdition16: {
      code: "98789",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "16 Coins Grand Platinum Edition",
      name: "16 Coins Grand Platinum Edition",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/16CoinsGrandPlatinumEdition.jpg",
      redirectUrl: "/casino/aggapvoltent-16-coins-grand-platinum-edition",
    },
    CoinsGrandGoldEditionEasterJackpots25: {
      code: "56968",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "25 Coins Grand Gold Edition Easter Jackpots",
      name: "25 Coins Grand Gold Edition Easter Jackpots",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/25CoinsGrandGoldEditionEasterJackpots.jpg",
      redirectUrl:
        "/casino/aggapvoltent-25-coins-grand-gold-edition-easter-jackpots",
    },
    CoinsGrandGoldEdition25: {
      code: "67660",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "25 Coins Grand Gold Edition",
      name: "25 Coins Grand Gold Edition",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/25CoinsGrandGoldEdition.jpg",
      redirectUrl: "/casino/aggapvoltent-25-coins-grand-gold-edition",
    },
    CoinsLovetheJackpot30: {
      code: "67580",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "30 Coins Love the Jackpot",
      name: "30 Coins Love the Jackpot",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/30CoinsLovetheJackpot.jpg",
      redirectUrl: "/casino/aggapvoltent-30-coins-love-the-jackpot",
    },
    CoinsEasterJackpots36: {
      code: "67600",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "36 Coins Easter Jackpots",
      name: "36 Coins Easter Jackpots",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/36CoinsEasterJackpots.jpg",
      redirectUrl: "/casino/aggapvoltent-36-coins-easter-jackpots",
    },
    CoinsLovetheJackpot36: {
      code: "87564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "36 Coins Love the Jackpot",
      name: "36 Coins Love the Jackpot",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/36CoinsLovetheJackpot.jpg",
      redirectUrl: "/casino/aggapvoltent-36-coins-love-the-jackpot",
    },
    HotSlot777GoldCrown: {
      code: "67620",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Slot: 777 Gold Crown",
      name: "Hot Slot: 777 Gold Crown",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/HotSlot777GoldCrown.jpg",
      redirectUrl: "/casino/aggapvoltent-hot-slot-777-gold-crown",
    },
    HotSlot777HoldtheJackpot: {
      code: "67567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Slot: 777 Hold the Jackpot",
      name: "Hot Slot: 777 Hold the Jackpot",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/HotSlot777HoldtheJackpot.jpg",
      redirectUrl: "/casino/aggapvoltent-hot-slot-777-hold-the-jackpot",
    },
    HotSlotGoldCoins: {
      code: "67570",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Slot: Gold Coins",
      name: "Hot Slot: Gold Coins",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/HotSlotGoldCoins.jpg",
      redirectUrl: "/casino/aggapvoltent-hot-slot-gold-coins",
    },
    MightyFishBlueMarlinLovetheJackpot: {
      code: "56767",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Fish: Blue Marlin Love the Jackpot",
      name: "Mighty Fish: Blue Marlin Love the Jackpot",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightyFishBlueMarlinLovetheJackpot.jpg",
      redirectUrl:
        "/casino/aggapvoltent-mighty-fish-blue-marlin-love-the-jackpot",
    },
    MightySymbolsJokersEasterJackpots: {
      code: "98788",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Symbols: Jokers Easter Jackpots",
      name: "Mighty Symbols: Jokers Easter Jackpots",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightySymbolsJokersEasterJackpots.jpg",
      redirectUrl: "/casino/aggapvoltent-mighty-symbols-jokers-easter-jackpots",
    },
    MightySymbolsJokersLovetheJackpot: {
      code: "98791",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Symbols: Jokers Love the Jackpot",
      name: "Mighty Symbols: Jokers Love the Jackpot",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightySymbolsJokersLovetheJackpot.jpg",
      redirectUrl:
        "/casino/aggapvoltent-mighty-symbols-jokers-love-the-jackpot",
    },
    MightyWildPantherGrandDiamondEditionEasterJackpots: {
      code: "67630",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Wild: Panther Grand Diamond Edition Easter Jackpots",
      name: "Mighty Wild: Panther Grand Diamond Edition Easter Jackpots",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightyWildPantherGrandDiamondEditionEasterJackpots.jpg",
      redirectUrl:
        "/casino/aggapvoltent-mighty-wild-panther-grand-diamond-edition-easter-jackpots",
    },
    MightyWildPantherGrandDiamondEditionLovetheJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Wild: Panther Grand Diamond Edition Love the Jackpot",
      name: "Mighty Wild: Panther Grand Diamond Edition Love the Jackpot",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightyWildPantherGrandDiamondEditionLovetheJackpot.jpg",
      redirectUrl:
        "/casino/aggapvoltent-mighty-wild-panther-grand-diamond-edition-love-the-jackpot",
    },
    OneCoinEasterJackpots: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "One Coin Easter Jackpots",
      name: "One Coin Easter Jackpots",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/OneCoinEasterJackpots.jpg",
      redirectUrl: "/casino/aggapvoltent-one-coin-easter-jackpots",
    },
    OneCoinLovetheJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "One Coin Love the Jackpot",
      name: "One Coin Love the Jackpot",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/OneCoinLovetheJackpot.jpg",
      redirectUrl: "/casino/aggapvoltent-one-coin-love-the-jackpot",
    },
    PowerofGodsHadesLovetheJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Power of Gods: Hades Love the Jackpot",
      name: "Power of Gods: Hades Love the Jackpot",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/PowerofGodsHadesLovetheJackpot.jpg",
      redirectUrl: "/casino/aggapvoltent-power-of-gods-hades-love-the-jackpot",
    },
    PowerofSunSvargLovetheJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Power of Sun: Svarog Love the Jackpot",
      name: "Power of Sun: Svarog Love the Jackpot",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/PowerofSunSvargLovetheJackpot.jpg",
      redirectUrl: "/casino/aggapvoltent-power-of-sun-svarog-love-the-jackpot",
    },
    SizzlingEggsGrandGoldEdition: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sizzling Eggs Grand Gold Edition",
      name: "Sizzling Eggs Grand Gold Edition",
      providerName: "Video Slots",
      imgUrl: "./images/alt-gaming/Voltent/SizzlingEggsGrandGoldEdition.jpg",
      redirectUrl: "/casino/aggapvoltent-sizzling-eggs-grand-gold-edition",
    },
    MightyWildPantherGrandGoldEditionLovetheJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Wild: Panther Grand Gold Edition Love the Jackpot",
      name: "Mighty Wild: Panther Grand Gold Edition Love the Jackpot",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightyWildPantherGrandGoldEditionLovetheJackpot.jpg",
      redirectUrl:
        "/casino/aggapvoltent-mighty-wild-panther-grand-gold-edition-love-the-jackpot",
    },
    MightyWildPantherGrandPlatinumEditionLovetheJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mighty Wild: Panther Grand Platinum Edition Love the Jackpot",
      name: "Mighty Wild: Panther Grand Platinum Edition Love the Jackpot",
      providerName: "Video Slots",
      imgUrl:
        "./images/alt-gaming/Voltent/MightyWildPantherGrandPlatinumEditionLovetheJackpot.jpg",
      redirectUrl:
        "/casino/aggapvoltent-mighty-wild-panther-grand-platinum-edition-love-the-jackpot",
    },
  },
  iconic21Gaming: {
    AndarBahar: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/andarbahar.jpg",
      redirectUrl: "/casino/aggapiconic21-andar-bahar",
    },
    BaccaratTable2NoComission: {
      code: "67720",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat Table 2 No Comission",
      name: "Baccarat Table 2 No Comission",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/BaccaratTable2NoComission.jpg",
      redirectUrl: "/casino/aggapiconic21-baccarat-table-2-no-comission",
    },
    BaccaratTable2: {
      code: "92037",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat Table 2",
      name: "Baccarat Table 2",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/BaccaratTable2.jpg",
      redirectUrl: "/casino/aggapiconic21-baccarat-table-2",
    },
    blackjack360midnight: {
      code: "92038",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack 360 Midnight",
      name: "Blackjack 360 Midnight",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/blackjack360midnight.jpg",
      redirectUrl: "/casino/aggapiconic21-blackjack-360-midnight",
    },
    blackjackmidday: {
      code: "67610",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack 360 Midday",
      name: "Blackjack 360 Midday",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/blackjackmidday.jpg",
      redirectUrl: "/casino/aggapiconic21-blackjack-360-midday",
    },
    blackjacksunrise: {
      code: "67670",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack 360 Sunrise",
      name: "Blackjack 360 Sunrise",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/blackjacksunrise.jpg",
      redirectUrl: "/casino/aggapiconic21-blackjack-360-sunrise",
    },
    blackjacksunset: {
      code: "90100",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack 360 Sunset",
      name: "Blackjack 360 Sunset",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/blackjacksunset.jpg",
      redirectUrl: "/casino/aggapiconic21-blackjack-360-sunset",
    },
    cricketroulette: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket Roulette",
      name: "Cricket Roulette",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/cricketroulette.jpg",
      redirectUrl: "/casino/aggapiconic21-cricket-roulette",
    },
    dragontiger: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Virtual Dragon Tiger",
      name: "Virtual Dragon Tiger",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/dragontiger.jpg",
      redirectUrl: "/casino/aggapiconic21-virtual-dragon-tiger",
    },
    grandbonusblackjack: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Grand Bonus Blackjack",
      name: "Grand Bonus Blackjack",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/grandbonusblackjack.jpg",
      redirectUrl: "/casino/aggapiconic21-grand-bonus-blackjack",
    },
    gravityblackjack: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gravity Blackjack",
      name: "Gravity Blackjack",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/gravityblackjack.jpg",
      redirectUrl: "/casino/aggapiconic21-gravity-blackjack",
    },
    lightspeed: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lightspeed",
      name: "Lightspeed",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/lightspeed.jpg",
      redirectUrl: "/casino/aggapiconic21-lightspeed",
    },
    literoulette: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lite Roulette",
      name: "Lite Roulette",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/literoulette1.jpg",
      redirectUrl: "/casino/aggapiconic21-lite-roulette",
    },
    LiveBaccarat2NC: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Live Baccarat 2 NC",
      name: "Live Baccarat 2 NC",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/LiveBaccarat2NC.jpg",
      redirectUrl: "/casino/aggapiconic21-live-baccarat-2-nc",
    },
    livebacarrat: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Live Baccarat 2",
      name: "Live Baccarat 2",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/livebacarrat.jpg",
      redirectUrl: "/casino/aggapiconic21-live-baccarat-2",
    },
    royalroulette: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Royal Roulette",
      name: "Royal Roulette",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/royalroulette.jpg",
      redirectUrl: "/casino/aggapiconic21-royal-roulette",
    },
    sicbo: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sic Bo",
      name: "Sic Bo",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/sicbo1.jpg",
      redirectUrl: "/casino/aggapiconic21-sic-bo",
    },
    topcard: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Top Card",
      name: "Top Card",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/topcard.jpg",
      redirectUrl: "/casino/aggapiconic21-top-card",
    },
    VirtualTopCard: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Virtual Top Card",
      name: "Virtual Top Card",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/VirtualTopCard.jpg",
      redirectUrl: "/casino/aggapiconic21-virtual-top-card",
    },
    vipblackjack: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Vip Blackjack",
      name: "Vip Blackjack",
      providerName: "ICONIC21",
      imgUrl: "./images/alt-gaming/Iconic21/vipblackjack.jpg",
      redirectUrl: "/casino/aggapiconic21-vip-blackjack",
    },
  },
  turboGaming: {
    TapMines1: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "1Tap Mines",
      name: "1Tap Mines",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/1tapmines.jpg",
      redirectUrl: "/casino/aggapturbogames-1tap-mines",
    },
    aero: {
      code: "56768",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Aero",
      name: "Aero",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/aero.jpg",
      redirectUrl: "/casino/aggapturbogames-aero",
    },
    bookofmines: {
      code: "98790",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "BOOK OF MINES",
      name: "BOOK OF MINES",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/bookofmines.jpg",
      redirectUrl: "/casino/aggapturbogames-book-of-mines",
    },
    bubbles: {
      code: "98789",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bubbles",
      name: "Bubbles",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/bubbles.jpg",
      redirectUrl: "/casino/aggapturbogames-bubbles",
    },
    catanza: {
      code: "56968",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Catanza",
      name: "Catanza",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/catanza.jpg",
      redirectUrl: "/casino/aggapturbogames-catanza",
    },
    cricketboom: {
      code: "67660",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket Boom",
      name: "Cricket Boom",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/cricketboom.jpg",
      redirectUrl: "/casino/aggapturbogames-cricket-boom",
    },
    crystalpoker: {
      code: "67580",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crystal Poker",
      name: "Crystal Poker",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/crystalpoker.jpg",
      redirectUrl: "/casino/aggapturbogames-crystal-poker",
    },
    dicethrice: {
      code: "67600",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dice Thrice",
      name: "Dice Thrice",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/dicethrice.jpg",
      redirectUrl: "/casino/aggapturbogames-dice-thrice",
    },
    dogsstreet: {
      code: "87564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dogs Street",
      name: "Dogs Street",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/dogsstreet.jpg",
      redirectUrl: "/casino/aggapturbogames-dogs-street-u4503",
    },
    donnyking: {
      code: "67620",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "",
      name: "Donny King",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/donnyking.jpg",
      redirectUrl: "/casino/aggapturbogames-donny-king",
    },
    doubleroll: {
      code: "67567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Double Roll",
      name: "Double Roll",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/doubleroll.jpg",
      redirectUrl: "/casino/aggapturbogames-double-roll",
    },
    fastfielder: {
      code: "67570",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fast Fielder",
      name: "Fast Fielder",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/fastfielder.jpg",
      redirectUrl: "/casino/aggapturbogames-fast-fielder",
    },
    fruitstowers: {
      code: "56767",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fruit Towers",
      name: "Fruit Towers",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/fruitstowers.jpg",
      redirectUrl: "/casino/aggapturbogames-fruit-towers",
    },
    hilo: {
      code: "98788",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hi-Lo",
      name: "Hi-Lo",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/hi-lo.jpg",
      redirectUrl: "/casino/aggapturbogames-hi-lo",
    },
    jewelclicker: {
      code: "98791",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jewel Clicker",
      name: "Jewel Clicker",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/jewelclicker.jpg",
      redirectUrl: "/casino/aggapturbogames-jewel-clicker",
    },
    magickeno: {
      code: "67630",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Magic Keno",
      name: "Magic Keno",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/magickeno.jpg",
      redirectUrl: "/casino/aggapturbogames-magic-keno",
    },
    multiplayermines: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Multiplayer Mines",
      name: "Multiplayer Mines",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/multiplayermines.jpg",
      redirectUrl: "/casino/aggapturbogames-multiplayer-mines",
    },
    pumpedX: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "PumpedX",
      name: "PumpedX",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/pumpedX.jpg",
      redirectUrl: "/casino/aggapturbogames-pumpedx",
    },
    spinstrike: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Spin Strike",
      name: "Spin Strike",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/spinstrike.jpg",
      redirectUrl: "/casino/aggapturbogames-spin-strike",
    },
    takemyplinko: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Take My Plinko",
      name: "Take My Plinko",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/takemyplinko.jpg",
      redirectUrl: "/casino/aggapturbogames-take-my-plinko",
    },
    tradingdice: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trading Dice",
      name: "Trading Dice",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/tradingdice.jpg",
      redirectUrl: "/casino/aggapturbogames-trading-dice",
    },
    turbomines: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Turbo Mines",
      name: "Turbo Mines",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/turbomines.jpg",
      redirectUrl: "/casino/aggapturbogames-turbo-mines",
    },
    turboplinko: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Turbo Plinko",
      name: "Turbo Plinko",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/turboplinko.jpg",
      redirectUrl: "/casino/aggapturbogames-turbo-plinko",
    },
    vortex: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VORTEX",
      name: "VORTEX",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/vortex.jpg",
      redirectUrl: "/casino/aggapturbogames-vortex",
    },
    wicketblast: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wicket Blast",
      name: "Wicket Blast",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/wicketblast.jpg",
      redirectUrl: "/casino/aggapturbogames-wicket-blast",
    },
  },
  pgsoftGaming: {
    anubiswrath: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Anubis Wrath",
      name: "Anubis Wrath",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/anubiswrath.jpg",
      redirectUrl: "/casino/aggappgsoft-anubis-wrath",
    },
    BaccaratDeluxe: {
      code: "56768",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat Deluxe",
      name: "Baccarat Deluxe",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/BaccaratDeluxe.jpg",
      redirectUrl: "/casino/aggappgsoft-baccarat-deluxe",
    },
    cashmania: {
      code: "98790",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cash Mania",
      name: "Cash Mania",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/cashmania.jpg",
      redirectUrl: "/casino/aggappgsoft-cash-mania",
    },
    chickyrun: {
      code: "98789",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Chicky Run",
      name: "Chicky Run",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/chickyrun.jpg",
      redirectUrl: "/casino/aggappgsoft-chicky-run",
    },
    chocolatedeluxe: {
      code: "56968",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Chocolate Deluxe",
      name: "Chocolate Deluxe",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/chocolatedeluxe.jpg",
      redirectUrl: "/casino/aggappgsoft-chocolate-deluxe",
    },
    dragonhatch2: {
      code: "67660",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Hatch 2",
      name: "Dragon Hatch 2",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/dragonhatch2.jpg",
      redirectUrl: "/casino/aggappgsoft-dragon-hatch-2",
    },
    fortunedragon: {
      code: "67580",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Dragon",
      name: "Fortune Dragon",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/fortunedragon.jpg",
      redirectUrl: "/casino/aggappgsoft-fortune-dragon",
    },
    fortunesnake: {
      code: "67600",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Snake",
      name: "Fortune Snake",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/fortunesnake.jpg",
      redirectUrl: "/casino/aggappgsoft-fortune-snake",
    },
    futebolfever: {
      code: "87564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Futebol Fever",
      name: "Futebol Fever",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/futebolfever.jpg",
      redirectUrl: "/casino/aggappgsoft-futebol-fever",
    },
    geishasrevenge: {
      code: "67620",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Geisha's Revenge",
      name: "Geisha's Revenge",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/geishasrevenge.jpg",
      redirectUrl: "/casino/aggappgsoft-geishas-revenge",
    },
    gemstonegold: {
      code: "67567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: " Gemstones Gold",
      name: "Gemstones Gold",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/gemstonegold.jpg",
      redirectUrl: "/casino/aggappgsoft-gemstones-gold",
    },
    mafiamayhem: {
      code: "67570",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mafia Mayhem",
      name: "Mafia Mayhem",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/mafiamayhem.jpg",
      redirectUrl: "/casino/aggappgsoft-mafia-mayhem",
    },
    museummystery: {
      code: "56767",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Museum Mystery",
      name: "Museum Mystery",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/museummystery.jpg",
      redirectUrl: "/casino/aggappgsoft-museum-mystery",
    },
    mysticpotion: {
      code: "98788",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mystic Potion",
      name: "Mystic Potion",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/mysticpotion.jpg",
      redirectUrl: "/casino/aggappgsoft-mystic-potion",
    },
    oishidelights: {
      code: "98791",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Oishi Delights",
      name: "Oishi Delights",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/oishidelights.jpg",
      redirectUrl: "/casino/aggappgsoft-oishi-delights",
    },
    pinatawins: {
      code: "67630",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pinata Wins",
      name: "Pinata Wins",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/pinatawins1.jpg",
      redirectUrl: "/casino/aggappgsoft-pinata-wins",
    },
    riofantasia: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rio Fantasia",
      name: "Rio Fantasia",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/riofantasia.jpg",
      redirectUrl: "/casino/aggappgsoft-rio-fantasia",
    },
    sharkbounty: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "sharkbounty",
      name: "sharkbounty",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/sharkbounty.jpg",
      redirectUrl: "/casino/aggappgsoft-shark-hunter",
    },
    threecrazypiggies: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Three Crazy Piggies",
      name: "Three Crazy Piggies",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/threecrazypiggies.jpg",
      redirectUrl: "/casino/aggappgsoft-three-crazy-piggies",
    },
    tsartreasures: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tsar Treasures",
      name: "Tsar Treasures",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/tsartreasures.jpg",
      redirectUrl: "/casino/aggappgsoft-tsar-treasures",
    },
    werewolfshunt: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Werewolf's Hunt",
      name: "Werewolf's Hunt",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/werewolfshunt.jpg",
      redirectUrl: "/casino/aggappgsoft-werewolfs-hunt",
    },
    wildape3258: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Ape #3258",
      name: "Wild Ape #3258",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/wildape3258.jpg",
      redirectUrl: "/casino/aggappgsoft-wild-ape-3258",
    },
    wingsofiguazu: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wings of Iguazu",
      name: "Wings of Iguazu",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/wingsofiguazu.jpg",
      redirectUrl: "/casino/aggappgsoft-wings-of-iguazu",
    },
    yakuzahonor: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Yakuza Honor",
      name: "Yakuza Honor",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/yakuzahonor.jpg",
      redirectUrl: "/casino/aggappgsoft-yakuza-honor",
    },
    zombieoutbreak: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Zombie Outbreak",
      name: "Zombie Outbreak",
      providerName: "PGSoft",
      imgUrl: "./images/alt-gaming/PG-Soft/zombieoutbreak.jpg",
      redirectUrl: "/casino/aggappgsoft-zombie-outbreak",
    },
  },
  boomingGames: {
    goldcoinsholdandwin64: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "64 Gold Coins Hold and Win",
      name: "64 Gold Coins Hold and Win",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/64goldcoinsholdandwin.jpg",
      redirectUrl: "/casino/aggapboominggames-64-gold-coins-hold-and-win",
    },
    buffaloholdandwinextreme10000: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Buffalo Hold and Win Extreme 10,000",
      name: "Buffalo Hold and Win Extreme 10,000",
      providerName: "Booming Games",
      imgUrl:
        "./images/alt-gaming/Boominggames/buffaloholdandwinextreme10000.jpg",
      redirectUrl:
        "/casino/aggapboominggames-buffalo-hold-and-win-extreme-10000",
    },
    burningclassicsroyaledition: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Burning Classics Royal Edition",
      name: "Burning Classics Royal Edition",
      providerName: "Booming Games",
      imgUrl:
        "./images/alt-gaming/Boominggames/burningclassicsroyaledition.jpg",
      redirectUrl: "/casino/aggapboominggames-burning-classics-royal-edition",
    },
    burninglove: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Burning Love",
      name: "Burning Love",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/burninglove.jpg",
      redirectUrl: "/casino/aggapboominggames-burning-love",
    },
    cashpig2: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cash Pig 2",
      name: "Cash Pig 2",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/cashpig2.jpg",
      redirectUrl: "/casino/aggapboominggames-cash-pig-2",
    },
    chiefhawkspiritwalk: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cash Pig 2",
      name: "Cash Pig 2",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/chiefhawkspiritwalk.jpg",
      redirectUrl: "/casino/aggapboominggames-chief-hawks-spirit-walk",
    },
    classiccoins: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Classic Coins",
      name: "Classic Coins",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/classiccoins.jpg",
      redirectUrl: "/casino/aggapboominggames-classic-coins",
    },
    coincrusherholdandwin: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Coin Crusher Hold And Win",
      name: "Coin Crusher Hold And Win",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/coincrusherholdandwin.jpg",
      redirectUrl: "/casino/aggapboominggames-coin-crusher-hold-and-win",
    },
    diamondshits: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Diamond Hits",
      name: "Diamond Hits",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/diamondshits.jpg",
      redirectUrl: "/casino/aggapboominggames-diamond-hits",
    },
    dynamitetrio: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dynamite Trio",
      name: "Dynamite Trio",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/dynamitetrio.jpg",
      redirectUrl: "/casino/aggapboominggames-dynamite-trio",
    },
    easterclassic: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Easter Classics",
      name: "Easter Classics",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/easterclassic.jpg",
      redirectUrl: "/casino/aggapboominggames-easter-classics",
    },
    fishtalesmonsterbass: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fish Tales Monster Bass",
      name: "Fish Tales Monster Bass",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/fishtalesmonsterbass.jpg",
      redirectUrl: "/casino/aggapboominggames-fish-tales-monster-bass",
    },
    goldgoldgold5000: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gold Gold Gold 5000",
      name: "Gold Gold Gold 5000",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/goldgoldgold5000.jpg",
      redirectUrl: "/casino/aggapboominggames-gold-gold-gold-5000",
    },
    hollyjollybonananza2: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Holly Jolly Bonanza 2",
      name: "Holly Jolly Bonanza 2",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/hollyjollybonananza2.jpg",
      redirectUrl: "/casino/aggapboominggames-holly-jolly-bonanza-2",
    },
    hollyjollybonanza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Holly Jolly Bonanza",
      name: "Holly Jolly Bonanza",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/hollyjollybonanza.jpg",
      redirectUrl: "/casino/aggapboominggames-holly-jolly-bonanza",
    },
    hollyjollycashpig: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Holly Jolly Cash Pig",
      name: "Holly Jolly Cash Pig",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/hollyjollycashpig.jpg",
      redirectUrl: "/casino/aggapboominggames-holly-jolly-cash-pig",
    },
    hotcharge: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Charge",
      name: "Hot Charge",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/hotcharge.jpg",
      redirectUrl: "/casino/aggapboominggames-hot-charge",
    },
    howlingforgold: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Howling for Gold",
      name: "Howling for Gold",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/howlingforgold.jpg",
      redirectUrl: "/casino/aggapboominggames-howling-for-gold",
    },
    jestersbellbonanza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jester's Bells Bonanza",
      name: "Jester's Bells Bonanza",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/jestersbellbonanza.jpg",
      redirectUrl: "/casino/aggapboominggames-jesters-bells-bonanza",
    },
    ronaldinhoscores: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ronaldinho Scores",
      name: "Ronaldinho Scores",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/ronaldinhoscores.jpg",
      redirectUrl: "/casino/aggapboominggames-ronaldinho-scores",
    },
    spacesamwalkandwin: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Space Sam Walk and Win",
      name: "Space Sam Walk and Win",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/spacesamwalkandwin.jpg",
      redirectUrl: "/casino/aggapboominggames-space-sam-walk-and-win",
    },
    spooktacularbonanza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Spooktacular Bonanza",
      name: "Spooktacular Bonanza",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/spooktacularbonanza.jpg",
      redirectUrl: "/casino/aggapboominggames-spooktacular-bonanza",
    },
    tastybonanza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tasty Bonanza",
      name: "Tasty Bonanza",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/tastybonanza.jpg",
      redirectUrl: "/casino/aggapboominggames-tasty-bonanza",
    },
    thewildwingsofphoenixdeluxe: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Wild Wings of Phoenix Deluxe",
      name: "The Wild Wings of Phoenix Deluxe",
      providerName: "Booming Games",
      imgUrl:
        "./images/alt-gaming/Boominggames/thewildwingsofphoenixdeluxe.jpg",
      redirectUrl: "/casino/aggapboominggames-the-wild-wings-of-phoenix-deluxe",
    },
    TNTbonanza2: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "TNT Bonanza 2",
      name: "TNT Bonanza 2",
      providerName: "Booming Games",
      imgUrl: "./images/alt-gaming/Boominggames/TNTbonanza2.jpg",
      redirectUrl: "/casino/aggapboominggames-tnt-bonanza-2",
    },
  },
  betGames: {
    poker6: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "6+ Poker",
      name: "6+ Poker",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/6+poker.jpg",
      redirectUrl: "/casino/aggapbetgames-6-poker",
    },
    badbaboons: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bad Baboons",
      name: "Bad Baboons",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/badbaboons.jpg",
      redirectUrl: "/casino/aggapbetgames-bad-baboons",
    },
    betonbaccarat: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bet On Baccarat",
      name: "Bet On Baccarat",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/betonbaccarat.jpg",
      redirectUrl: "/casino/aggapbetgames-bet-on-baccarat",
    },
    betonpoker: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bet On Poker",
      name: "Bet On Poker",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/betonpoker.jpg",
      redirectUrl: "/casino/aggapbetgames-bet-on-poker",
    },
    candycoins: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Candy Coins",
      name: "Candy Coins",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/candycoins.jpg",
      redirectUrl: "/casino/aggapbetgames-candy-coins",
    },
    citrussplash: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Citrus Splash",
      name: "Citrus Splash",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/citrussplash.jpg",
      redirectUrl: "/casino/aggapbetgames-citrus-splash",
    },
    classicroulette: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Classic Roulette",
      name: "Classic Roulette",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/classicroulette.jpg",
      redirectUrl: "/casino/aggapbetgames-classic-roulette",
    },
    classicwheel: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Classic Wheel",
      name: "Classic Wheel",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/classicwheel.jpg",
      redirectUrl: "/casino/aggapbetgames-classic-wheel",
    },
    cryptofgizasecretsuneviled: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crypt Of Giza - Secrets Unveiled",
      name: "Crypt Of Giza - Secrets Unveiled",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/cryptofgizasecretsuneviled.jpg",
      redirectUrl: "/casino/aggapbetgames-crypt-of-giza-secrets-unveiled",
    },
    cryptofgiza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crypt of Giza",
      name: "Crypt of Giza",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/cryptofgiza.jpg",
      redirectUrl: "/casino/aggapbetgames-crypt-of-giza",
    },
    diceduel: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dice Duel",
      name: "Dice Duel",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/diceduel.jpg",
      redirectUrl: "/casino/aggapbetgames-dice-duel",
    },
    dragonsfate: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon's Fate",
      name: "Dragon's Fate",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/dragonsfate.jpg",
      redirectUrl: "/casino/aggapbetgames-dragons-fate",
    },
    flashroulette: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Flash Roulette",
      name: "Flash Roulette",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/flashroulette.jpg",
      redirectUrl: "/casino/aggapbetgames-flash-roulette",
    },
    footballgrid: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Football Grid",
      name: "Football Grid",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/footballgrid.jpg",
      redirectUrl: "/casino/aggapbetgames-football-grid",
    },
    instantlucky7: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Instant Lucky 7",
      name: "Instant Lucky 7",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/instantlucky7.jpg",
      redirectUrl: "/casino/aggapbetgames-instant-lucky-7",
    },
    lotuswealthwonders: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lotus Wealth Wonders",
      name: "Lotus Wealth Wonders",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/lotuswealthwonders.jpg",
      redirectUrl: "/casino/aggapbetgames-lotus-wealth-wonders",
    },
    lucky5: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky 5",
      name: "Lucky 5",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/lucky5.jpg",
      redirectUrl: "/casino/aggapbetgames-lucky-5",
    },
    lucky6: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky 6",
      name: "Lucky 6",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/lucky6.jpg",
      redirectUrl: "/casino/aggapbetgames-lucky-6",
    },
    lucky7: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky7",
      name: "Lucky7",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/lucky7.jpg",
      redirectUrl: "/casino/aggapbetgames-lucky-7",
    },
    penguinrush: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Penguin Rush",
      name: "Penguin Rush",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/penguinrush.jpg",
      redirectUrl: "/casino/aggapbetgames-penguin-rush",
    },
    skyward: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Skyward",
      name: "Skyward",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/skyward.jpg",
      redirectUrl: "/casino/aggapbetgames-skyward",
    },
    speedy7: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Speedy 7",
      name: "Speedy 7",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/speedy7.jpg",
      redirectUrl: "/casino/aggapbetgames-speedy-7",
    },
    starzle: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Starzle",
      name: "Starzle",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/starzle.jpg",
      redirectUrl: "/casino/aggapbetgames-starzle",
    },
    warofbets: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "War Of Bets",
      name: "War Of Bets",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/warofbets.jpg",
      redirectUrl: "/casino/aggapbetgames-war-of-bets",
    },
    wheeloffortune: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wheel Of Fortune",
      name: "Wheel Of Fortune",
      providerName: "BetGames",
      imgUrl: "./images/alt-gaming/Betgames/wheeloffortune.jpg",
      redirectUrl: "/casino/aggapbetgames-wheel-of-fortune",
    },
  },
  playnGoGaming: {
    mystergeniefortunes1001: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "1001 Mystery Genie Fortunes",
      name: "1001 Mystery Genie Fortunes",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/1001mystergeniefortunes.jpg",
      redirectUrl: "/casino/aggapplayngo-1001-mystery-genie-fortunes",
    },
    crystalhall: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crystal Hall",
      name: "Crystal Hall",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/crystalhall.jpg",
      redirectUrl: "/casino/aggapplayngo-crystal-hall",
    },
    gocraps: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "GO CRAPS",
      name: "GO CRAPS",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/gocraps.jpg",
      redirectUrl: "/casino/aggapplayngo-go-craps",
    },
    hotdogheist: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Dog Heist",
      name: "Hot Dog Heist",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/hotdogheist.jpg",
      redirectUrl: "/casino/aggapplayngo-hot-dog-heist",
    },
    invadingvegasrevengeonmars: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Invading Vegas Revenge on Mars",
      name: "Invading Vegas Revenge on Mars",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/invadingvegasrevengeonmars.jpg",
      redirectUrl: "/casino/aggapplayngo-invading-vegas-revenge-on-mars",
    },
    jollyrogerwildkraken: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jolly Roger Wild Kraken",
      name: "Jolly Roger Wild Kraken",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/jollyrogerwildkraken.jpg",
      redirectUrl: "/casino/aggapplayngo-jolly-roger-wild-kraken",
    },
    legacyofgemsblitzways: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Legacy of Gems Blitzways",
      name: "Legacy of Gems Blitzways",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/legacyofgemsblitzways.jpg",
      redirectUrl: "/casino/aggapplayngo-legacy-of-gems-blitzways",
    },
    legiongoldvictory: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Legion Gold Victory!",
      name: "Legion Gold Victory!",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/legiongoldvictory!.jpg",
      redirectUrl: "/casino/aggapplayngo-legion-gold-victory",
    },
    lionsageodyssey: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lion Saga Odyssey",
      name: "Lion Saga Odyssey",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/lionsageodyssey.jpg",
      redirectUrl: "/casino/aggapplayngo-lion-saga-odyssey",
    },
    lootandlabyrinths: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Loot and Labyrinths",
      name: "Loot and Labyrinths",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/lootandlabyrinths.jpg",
      redirectUrl: "/casino/aggapplayngo-loot-and-labyrinths",
    },
    loveisinthefair: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Love Is In The Fair",
      name: "Love Is In The Fair",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/loveisinthefair.jpg",
      redirectUrl: "/casino/aggapplayngo-love-is-in-the-fair",
    },
    medusasmadness: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Medusa's Madness",
      name: "Medusa's Madness",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/medusasmadness.jpg",
      redirectUrl: "/casino/aggapplayngo-medusas-madness",
    },
    midnightgold: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Midnight Gold",
      name: "Midnight Gold",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/midnightgold.jpg",
      redirectUrl: "/casino/aggapplayngo-midnight-gold",
    },
    minerdonkeyrider: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Miner Donkey Rider",
      name: "Miner Donkey Rider",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/minerdonkeyrider.jpg",
      redirectUrl: "/casino/aggapplayngo-miner-donkey-rider",
    },
    monkeybattleforthescrolls: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Monkey: Battle For The Scrolls",
      name: "Monkey: Battle For The Scrolls",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/monkeybattleforthescrolls.jpg",
      redirectUrl: "/casino/aggapplayngo-monkey-battle-for-the-scrolls",
    },
    MoonPrincessOrigins: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Moon Princess Origins",
      name: "Moon Princess Origins",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/MoonPrincessOrigins.jpg",
      redirectUrl: "/casino/aggapplayngo-moon-princess-origins",
    },
    mysteryeggsurprise: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mystery Egg Surprise",
      name: "Mystery Egg Surprise",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/mysteryeggsurprise.jpg",
      redirectUrl: "/casino/aggapplayngo-mystery-egg-surprise",
    },
    mythofdead: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Myth of Dead",
      name: "Myth of Dead",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/mythofdead.jpg",
      redirectUrl: "/casino/aggapplayngo-myth-of-dead",
    },
    potionofmadness: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Potion of Madness",
      name: "Potion of Madness",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/potionofmadness.jpg",
      redirectUrl: "/casino/aggapplayngo-potion-of-madness",
    },
    richwildeandthetomeofdead: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rich Wilde and the Tome of Dead",
      name: "Rich Wilde and the Tome of Dead",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/richwildeandthetomeofdead.jpg",
      redirectUrl: "/casino/aggapplayngo-rich-wilde-and-the-tome-of-dead",
    },
    sobeksgodlyspins: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sobek's Godly Spins",
      name: "Sobek's Godly Spins",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/sobeksgodlyspins.jpg",
      redirectUrl: "/casino/aggapplayngo-sobeks-godly-spins",
    },
    spinninRecordintothebeat: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Spinnin' Records Into the Beat",
      name: "Spinnin' Records Into the Beat",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/spinninRecordintothebeat.jpg",
      redirectUrl: "/casino/aggapplayngo-spinnin-records-into-the-beat",
    },
    towerquestlegacy: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tower Quest Legacy",
      name: "Tower Quest Legacy",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/towerquestlegacy.jpg",
      redirectUrl: "/casino/aggapplayngo-tower-quest-legacy",
    },
    treasureofkongar: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Treasures of Kongar",
      name: "Treasures of Kongar",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/treasureofkongar.jpg",
      redirectUrl: "/casino/aggapplayngo-treasures-of-kongar",
    },
    trinityimpact: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trinity Impact",
      name: "Trinity Impact",
      providerName: "Play'n Go",
      imgUrl: "./images/alt-gaming/playngo/trinityimpact.jpg",
      redirectUrl: "/casino/aggapplayngo-trinity-impact",
    },
  },
  playtechliveGaming: {
    allbetsblackjackbrasileira: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "All Bets Blackjack Brasileira",
      name: "All Bets Blackjack Brasileira",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/allbetsblackjackbrasileira.jpg",
      redirectUrl: "/casino/aggapplaytechlive-all-bets-blackjack-brasileira",
    },
    autoroulette2: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Auto Roulette 2",
      name: "Auto Roulette 2",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/autoroulette2.jpg",
      redirectUrl: "/casino/aggapplaytechlive-auto-roulette-2",
    },
    baccaratbrasileiranocommission: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat Brasileira No Comission",
      name: "Baccarat Brasileira No Comission",
      providerName: "Playtech Live",
      imgUrl:
        "./images/alt-gaming/playtechlive/baccaratbrasileiranocommission.jpg",
      redirectUrl: "/casino/aggapplaytechlive-baccarat-brasileira-no-comission",
    },
    baccaratbrasileira: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat Brasileira",
      name: "Baccarat Brasileira",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/baccaratbrasileira.jpg",
      redirectUrl: "/casino/aggapplaytechlive-baccarat-brasileira",
    },
    baccaratnocommission: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat No Commission",
      name: "Baccarat No Commission",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/baccaratnocommission.jpg",
      redirectUrl: "/casino/aggapplaytechlive-baccarat-no-comission",
    },
    blackjack2: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack 2",
      name: "Blackjack 2",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/blackjack2.jpg",
      redirectUrl: "/casino/aggapplaytechlive-blackjack-2",
    },
    blackjack10: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack 10",
      name: "Blackjack 10",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/blackjack10.jpg",
      redirectUrl: "/casino/aggapplaytechlive-blackjack-10",
    },
    blackjacksoiree4: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Blackjack SoirÃ©e 4",
      name: "Blackjack SoirÃ©e 4",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/blackjacksoiree4.jpg",
      redirectUrl: "/casino/aggapplaytechlive-blackjack-soirace-4",
    },
    cashcollectroulettelive: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cash Collect Roulette Live",
      name: "Cash Collect Roulette Live",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/cashcollectroulettelive.jpg",
      redirectUrl: "/casino/aggapplaytechlive-cash-collect-roulette-live",
    },
    deutschesspeedroulette: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Deutsches Speed Roulette",
      name: "Deutsches Speed Roulette",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/deutschesspeedroulette.jpg",
      redirectUrl: "/casino/aggapplaytechlive-deutsches-speed-roulette",
    },
    grandroyalecashback: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Grand Royale Cashback",
      name: "Grand Royale Cashback",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/grandroyalecashback.jpg",
      redirectUrl: "/casino/aggapplaytechlive-grand-royale-cashback",
    },
    japanesesqueezebaccaratnocommisison: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Japanese Squeeze Baccarat No Comission",
      name: "Japanese Squeeze Baccarat No Comission",
      providerName: "Playtech Live",
      imgUrl:
        "./images/alt-gaming/playtechlive/japanesesqueezebaccaratnocommisison.jpg",
      redirectUrl:
        "/casino/aggapplaytechlive-japanese-squeeze-baccarat-no-comission",
    },
    japanesesqueezebaccarat: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Japanese Squeeze Baccarat",
      name: "Japanese Squeeze Baccarat",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/japanesesqueezebaccarat.jpg",
      redirectUrl: "/casino/aggapplaytechlive-japanese-squeeze-baccarat",
    },
    koreanspeedbaccarat1nocommission: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Korean Speed Baccarat 1 No Comission",
      name: "Korean Speed Baccarat 1 No Comission",
      providerName: "Playtech Live",
      imgUrl:
        "./images/alt-gaming/playtechlive/koreanspeedbaccarat1nocommission.jpg",
      redirectUrl:
        "/casino/aggapplaytechlive-korean-speed-baccarat-1-no-comission",
    },
    koreanspeedbaccarat1: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Korean Speed Baccarat 1",
      name: "Korean Speed Baccarat 1",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/koreanspeedbaccarat1.jpg",
      redirectUrl: "/casino/aggapplaytechlive-korean-speed-baccarat-1",
    },
    luckyballroulette: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Ball Roulette",
      name: "Lucky Ball Roulette",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/luckyballroulette.jpg",
      redirectUrl: "/casino/aggapplaytechlive-lucky-ball-roulette",
    },
    megafireblazeblackjacklive: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mega Fire Blaze Blackjack Live",
      name: "Mega Fire Blaze Blackjack Live",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/megafireblazeblackjacklive.jpg",
      redirectUrl: "/casino/aggapplaytechlive-mega-fire-blaze-blackjack-live",
    },
    megafireblazeluckyballbrasileiro: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mega Fire Blaze Lucky Ball Brasileiro",
      name: "Mega Fire Blaze Lucky Ball Brasileiro",
      providerName: "Playtech Live",
      imgUrl:
        "./images/alt-gaming/playtechlive/megafireblazeluckyballbrasileiro.jpg",
      redirectUrl:
        "/casino/aggapplaytechlive-mega-fire-blaze-lucky-ball-brasileiro",
    },
    puntobancosoireegold: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Punto Banco Soirée Gold",
      name: "Punto Banco Soirée Gold",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/puntobancosoireegold.jpg",
      redirectUrl: "/casino/aggapplaytechlive-punto-banco-soiree-gold",
    },
    royaleblackjack2: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Royale Blackjack 2",
      name: "Royale Blackjack 2",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/royaleblackjack2.jpg",
      redirectUrl: "/casino/aggapplaytechlive-royale-blackjack-2",
    },
    RuYispeedbaccaratnocommission: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ru Yi Speed Baccarat No Comission",
      name: "Ru Yi Speed Baccarat No Comission",
      providerName: "Playtech Live",
      imgUrl:
        "./images/alt-gaming/playtechlive/RuYispeedbaccaratnocommission.jpg",
      redirectUrl:
        "/casino/aggapplaytechlive-ru-yi-speed-baccarat-no-comission",
    },
    RuYispeedbaccarat: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ru Yi Speed Baccarat",
      name: "Ru Yi Speed Baccarat",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/RuYispeedbaccarat.jpg",
      redirectUrl: "/casino/aggapplaytechlive-ru-yi-speed-baccarat",
    },
    speedsicbo: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Speed SicBo",
      name: "Speed SicBo",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/speedsicbo.jpg",
      redirectUrl: "/casino/aggapplaytechlive-speed-sicbo",
    },
    stickybanditsroulettelive: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sticky Bandits Roulette Live",
      name: "Sticky Bandits Roulette Live",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/stickybanditsroulettelive.jpg",
      redirectUrl: "/casino/aggapplaytechlive-sticky-bandits-roulette-live",
    },
    thegreatestcardshow: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Greatest Cards Show",
      name: "The Greatest Cards Show",
      providerName: "Playtech Live",
      imgUrl: "./images/alt-gaming/playtechlive/thegreatestcardshow.jpg",
      redirectUrl: "/casino/aggapplaytechlive-the-greatest-cards-show",
    },
  },

  smartsoftGaming: {
    bonusesbonanza4: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "4 Bonuses Bonanza",
      name: "4 Bonuses Bonanza",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/4bonusesbonanza.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-4-bonuses-bonanza",
    },
    baoslot5x: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bao Slot 5X",
      name: "Bao Slot 5X",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/baoslot5x.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-bao-slot-5x",
    },
    bookofbonanza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Book of Bonanza",
      name: "Book of Bonanza",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/bookofbonanza.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-book-of-bonanza",
    },
    bookoffuturia: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Book of Futuria",
      name: "Book of Futuria",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/bookoffuturia.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-book-of-futuria",
    },
    crashduelX: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash Duel X",
      name: "Crash Duel X",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/crashduelX.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-crash-duel-x",
    },
    cricketerX: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricketer X",
      name: "Cricketer X",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/cricketerX.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-cricketer-x",
    },
    foxyhot20: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Foxy Hot 20",
      name: "Foxy Hot 20",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/foxyhot20.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-foxy-hot-20",
    },
    geniesbonanza: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Genie's Bonanza",
      name: "Genie's Bonanza",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/geniesbonanza.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-genies-bonanza",
    },
    hotsamba: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Samba",
      name: "Hot Samba",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/hotsamba.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-hot-samba",
    },
    hunterX: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hunter X",
      name: "Hunter X",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/hunterX.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-hunter-x",
    },
    madslot: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mad Slot",
      name: "Mad Slot",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/madslot.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-mad-slot",
    },
    mineisland: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mad Slot",
      name: "Mad Slot",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/mineisland.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-mad-slot",
    },
    multihotways: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Multi Hot Ways",
      name: "Multi Hot Ways",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/multihotways.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-multi-hot-ways",
    },
    rollX: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Roll X",
      name: "Roll X",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/rollX.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-roll-x",
    },
    safarisimba: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Safari Simba",
      name: "Safari Simba",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/safarisimba.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-safari-simba",
    },
    sambadadeusa: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Samba Da Deusa",
      name: "Samba Da Deusa",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/sambadadeusa.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-samba-da-deusa",
    },
    slicerX: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "SlicerX",
      name: "SlicerX",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/slicerX.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-slicerx",
    },
    sugarfiesta: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sugar Fiesta",
      name: "Sugar Fiesta",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/sugarfiesta.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-sugar-fiesta",
    },
    towerx: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "TowerX",
      name: "TowerX",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/towerx.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-towerx",
    },
    wildjungle: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Jungle",
      name: "Wild Jungle",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/wildjungle.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-wild-jungle",
    },
    wildmultistars: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Multi Stars",
      name: "Wild Multi Stars",
      providerName: "Smartsoft Gaming",
      imgUrl: "./images/alt-gaming/smartsoft-gaming/wildmultistars.jpg",
      redirectUrl: "/casino/aggapsmartsoftgaming-wild-multi-stars",
    },
  },
  jiliGaming: {
     SicBo: {
        redirectUrl: "/casino/aggapjiligaming-sic-bo",
        code: "",
        casino: "Slots",
        providerName: "Jili Gaming",
        category: "jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/alt-gaming/jili-game/SicBo.jpg",
        alt: "Sic Bo",
        name: "Sic Bo",
      },
    ColorGame: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Color Game",
      name: "Color Game",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/colorgame.jpg",
      redirectUrl: "/casino/aggapjiligaming-color-game",
    },
    ColorPrediction: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Color Prediction",
      name: "Color Prediction",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ColorPrediction.jpg",
      redirectUrl: "/casino/aggapjiligaming-color-prediction",
    },
    PirateQueen: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pirate Queen",
      name: "Pirate Queen",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Piratequeen.jpg",
      redirectUrl: "/casino/aggapjiligaming-pirate-queen",
    },
    WildRacer: {
      code: "56768",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Racer",
      name: "Wild Racer",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Wildracer.jpg",
      redirectUrl: "/casino/aggapjiligaming-wild-racer",
    },
    NekoFortune: {
      code: "98790",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Neko Fortune",
      name: "Neko Fortune",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/nekofortune.jpg",
      redirectUrl: "/casino/aggapjiligaming-neko-fortune",
    },
    Samba: {
      code: "98789",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Samba",
      name: "Samba",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/samba.jpg",
      redirectUrl: "/casino/aggapjiligaming-samba",
    },
    WorldCup: {
      code: "56968",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "World Cup",
      name: "World Cup",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/worldcup.jpg",
      redirectUrl: "/casino/aggapjiligaming-world-cup",
    },
    BonusHunter: {
      code: "67660",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bonus Hunter",
      name: "Bonus Hunter",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bonushunter.jpg",
      redirectUrl: "/casino/aggapjiligaming-bonus-hunter",
    },
    JILICAISHEN: {
      code: "67580",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "JILI CAISHEN",
      name: "JILI CAISHEN",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jilicaishen.jpg",
      redirectUrl: "/casino/aggapjiligaming-jili-caishen",
    },
    MayanEmpire: {
      code: "67600",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mayan Empire",
      name: "Mayan Empire",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mayanempire.jpg",
      redirectUrl: "/casino/aggapjiligaming-mayan-empire",
    },
    BoneFortune: {
      code: "87564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bone Fortune",
      name: "Bone Fortune",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bonefortune.jpg",
      redirectUrl: "/casino/aggapjiligaming-bone-fortune",
    },
    GoldRush: {
      code: "67620",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gold Rush",
      name: "Gold Rush",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/goldrush.jpg",
      redirectUrl: "/casino/aggapjiligaming-gold-rush",
    },
    HappyTaxi: {
      code: "67567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Happy Taxi",
      name: "Happy Taxi",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/happytaxi.jpg",
      redirectUrl: "/casino/aggapjiligaming-happy-taxi",
    },
    ThorX: {
      code: "67570",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Thor X",
      name: "Thor X",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ThorX.jpg",
      redirectUrl: "/casino/aggapjiligaming-thor-x",
    },
    BookofGold: {
      code: "56767",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Book of Gold",
      name: "Book of Gold",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bookofgold.jpg",
      redirectUrl: "/casino/aggapjiligaming-book-of-gold",
    },
    Medusa: {
      code: "98788",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Medusa",
      name: "Medusa",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/medusa.jpg",
      redirectUrl: "/casino/aggapjiligaming-medusa",
    },
    GoGoalBingo: {
      code: "98791",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Go Goal Bingo",
      name: "Go Goal Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/gogoalbingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-go-goal-bingo",
    },
    ColorGame: {
      code: "67630",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Color Game",
      name: "Color Game",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/colorgame.jpg",
      redirectUrl: "/casino/aggapjiligaming-color-game",
    },
    JackpotBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jackpot Bingo",
      name: "Jackpot Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jackpotbingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-jackpot-bingo",
    },
    LuckyBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Bingo",
      name: "Lucky Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/luckybingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-lucky-bingo",
    },
    WinDrop: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Win Drop",
      name: "Win Drop",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/windrop.jpg",
      redirectUrl: "/casino/aggapjiligaming-win-drop",
    },
    FortuneBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Bingo",
      name: "Fortune Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortunebingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-fortune-bingo",
    },
    Baccarat: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/baccarat.jpg",
      redirectUrl: "/casino/aggapjiligaming-baccarat",
    },
    iRichBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "iRich Bingo",
      name: "iRich Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/iRichBingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-irich-bingo",
    },
    DragonTiger: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon & Tiger",
      name: "Dragon & Tiger",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Dragon_tiger.jpg",
      redirectUrl: "/casino/aggapjiligaming-dragon-and-tiger",
    },
    BigSmall: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Big Small",
      name: "Big Small",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Bigsmall.jpg",
      redirectUrl: "/casino/aggapjiligaming-big-small",
    },
    GoldenJoker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Joker",
      name: "Golden Joker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/goldenjoker.jpg",
      redirectUrl: "/casino/aggapjiligaming-golden-joker",
    },
    MasterTiger: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Master Tiger",
      name: "Master Tiger",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mastertiger.jpg",
      redirectUrl: "/casino/aggapjiligaming-master-tiger",
    },
    WildAce: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Ace",
      name: "Wild Ace",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Wildace.jpg",
      redirectUrl: "/casino/aggapjiligaming-wild-ace",
    },
    Crazy777: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy 777",
      name: "Crazy 777",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Crazy777.jpg",
      redirectUrl: "/casino/aggapjiligaming-crazy777",
    },
    DominoGo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Domino Go",
      name: "Domino Go",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/dominogo.jpg",
      redirectUrl: "/casino/aggapjiligaming-domino-go",
    },
    UltimateTexasHoldem: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ultimate Texas Hold'em",
      name: "Ultimate Texas Hold'em",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ultimatetexasholdem.jpg",
      redirectUrl: "/casino/aggapjiligaming-ultimate-texas-holdem",
    },
    KenoBonusNumber: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Keno Bonus Number",
      name: "Keno Bonus Number",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/KenoBonusNumber.jpg",
      redirectUrl: "/casino/aggapjiligaming-keno-bonus-number",
    },
    CrashCricket: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash Cricket",
      name: "Crash Cricket",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/CrashCricket.jpg",
      redirectUrl: "/casino/aggapjiligaming-crash-cricket",
    },
    CrashGoal: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash Goal",
      name: "Crash Goal",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crashgoal.jpg",
      redirectUrl: "/casino/aggapjiligaming-crash-goal",
    },
    FortuneRoulette: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Roulette",
      name: "Fortune Roulette",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortuneroulette.jpg",
      redirectUrl: "/casino/aggapjiligaming-fortune-roulette",
    },
    CricketRoulette: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket Roulette",
      name: "Cricket Roulette",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/cricketroulette.jpg",
      redirectUrl: "/casino/aggapjiligaming-cricket-roulette",
    },
    SuperESabong: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super E-Sabong",
      name: "Super E-Sabong",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/super-e-sabong.jpg",
      redirectUrl: "/casino/aggapjiligaming-super-e-sabong",
    },
    ThaiHilo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Thai Hilo",
      name: "Thai Hilo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/thaihilo.jpg",
      redirectUrl: "/casino/aggapjiligaming-thai-hilo",
    },
    BoxingExtravaganza: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Boxing Extravaganza",
      name: "Boxing Extravaganza",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/boxingextravaganza.jpg",
      redirectUrl: "/casino/aggapjiligaming-boxing-extravaganza",
    },
    JhandiMunda: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jhandi Munda",
      name: "Jhandi Munda",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jhandimunda.jpg",
      redirectUrl: "/casino/aggapjiligaming-jhandi-munda",
    },
    SuperAceScratch: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Ace Scratch",
      name: "Super Ace Scratch",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/superacescratch.jpg",
      redirectUrl: "/casino/aggapjiligaming-super-ace-scratch",
    },
    FishPrawnCrab: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fish Prawn Crab",
      name: "Fish Prawn Crab",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fishprawncrab.jpg",
      redirectUrl: "/casino/aggapjiligaming-fish-prawn-crab",
    },
    LuckyJaguar: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Jaguar",
      name: "Lucky Jaguar",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/luckyjaguar.jpg",
      redirectUrl: "/casino/aggapjiligaming-lucky-jaguar",
    },
    Shōgun: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Shōgun",
      name: "Shōgun",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/shogun.jpg",
      redirectUrl: "/casino/aggapjiligaming-shogun",
    },
    MoneyPot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Pot",
      name: "Money Pot",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/moneypot.jpg",
      redirectUrl: "/casino/aggapjiligaming-money-pot",
    },
    NightfallHunting: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Nightfall Hunting",
      name: "Nightfall Hunting",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/nightfallhunting.jpg",
      redirectUrl: "/casino/aggapjiligaming-nightfall-hunting",
    },
    PotDragons3: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Pot Dragons",
      name: "3 Pot Dragons",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/3potdragon.jpg",
      redirectUrl: "/casino/aggapjiligaming-3-pot-dragons",
    },
    Poseidon: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poseidon",
      name: "Poseidon",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/poseidon.jpg",
      redirectUrl: "/casino/aggapjiligaming-poseidon",
    },
    LuckyPiggy3: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Lucky Piggy",
      name: "3 Lucky Piggy",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/3luckypiggy.jpg",
      redirectUrl: "/casino/aggapjiligaming-3-lucky-piggy",
    },
    EgyptsGlow: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Egypt's Glow",
      name: "Egypt's Glow",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/egyptsglow.jpg",
      redirectUrl: "/casino/aggapjiligaming-egypts-glow",
    },
    PartyStar: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Party Star",
      name: "Party Star",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/partystar.jpg",
      redirectUrl: "/casino/aggapjiligaming-party-star",
    },
    MoneyComingExpandBets: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Coming Expand Bets",
      name: "Money Coming Expand Bets",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/moneycomingexpandedbets.jpg",
      redirectUrl: "/casino/aggapjiligaming-money-coming-expand-bets",
    },
    SuperAceeluxe: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Ace Deluxe",
      name: "Super Ace Deluxe",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/superacedeluxe.jpg",
      redirectUrl: "/casino/aggapjiligaming-super-ace-deluxe",
    },
    LegacyofEgypt: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Legacy of Egypt",
      name: "Legacy of Egypt",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/legacyofegypt.jpg",
      redirectUrl: "/casino/aggapjiligaming-legacy-of-egypt",
    },
    ThePigHouse: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Pig House",
      name: "The Pig House",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/thepighouse.jpg",
      redirectUrl: "/casino/aggapjiligaming-the-pig-house",
    },
    CrazyHunter2: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy Hunter 2",
      name: "Crazy Hunter 2",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crazyhunter2.jpg",
      redirectUrl: "/casino/aggapjiligaming-crazy-hunter-2",
    },
    FortuneKingJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune King Jackpot",
      name: "Fortune King Jackpot",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortunekingjackpot.jpg",
      redirectUrl: "/casino/aggapjiligaming-fortune-king-jackpot",
    },
    VideoPoker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Video Poker",
      name: "Video Poker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/videopoker.jpg",
      redirectUrl: "/casino/aggapjiligaming-video-poker",
    },
    CaribbeanStudPoker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Caribbean Stud Poker",
      name: "Caribbean Stud Poker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/caribbeanstudpoker.jpg",
      redirectUrl: "/casino/aggapjiligaming-caribbean-stud-poker",
    },
  },
  mac88Gaming: {
    RockPaperScissors: {
      code: "67564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rock Paper Scissors",
      name: "Rock Paper Scissors",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/rockpaperscissors.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-rock-paper-scissors",
    },
    Boys5: {
      code: "67720",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "5 Boys",
      name: "5 Boys",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/5boys.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-5-boys",
    },
    JetXT: {
      code: "92037",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jet XT",
      name: "Jet XT",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/jetxt.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-jet-xt",
    },
    Kitex: {
      code: "92038",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Kitex",
      name: "Kitex",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/kitex.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-kitex",
    },
    HiLo: {
      code: "67610",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hi Lo",
      name: "Hi Lo",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/hi-lo.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo",
    },
    PushpaRani: {
      code: "67670",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pushpa Rani",
      name: "Pushpa Rani",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/pushparani.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-pushpa-rani",
    },
    BallbyBallVR: {
      code: "90100",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ball by Ball VR",
      name: "Ball by Ball VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/ballbyballvr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-ball-by-ball-vr",
    },
    XRoulette: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "X Roulette",
      name: "X Roulette",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/xroulette.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-x-roulette",
    },
    Lucky15: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky 15",
      name: "Lucky 15",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/lucky15.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-lucky-15",
    },
    Vortex: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Vortex",
      name: "Vortex",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/vortex.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-vortex",
    },
    BollyKiss: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bolly Kiss",
      name: "Bolly Kiss",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/bollykiss.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-bolly-kiss",
    },
    Plinko: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Plinko",
      name: "Plinko",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/plinko.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-plinko",
    },
    diamonds: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Diamond",
      name: "Diamond",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/diamonds.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-diamonds",
    },
    mines: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mines",
      name: "Mines",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/mines.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-mines",
    },
    Limbo: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Limbo",
      name: "Limbo",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/limbo.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-limbo",
    },
    CrashX: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash X",
      name: "Crash X",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/crashx.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-crash-x",
    },
    Dice: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dice",
      name: "Dice",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/Dice.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-dice",
    },
    AK47VR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "AK47 VR",
      name: "AK47 VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/ak47vr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-ak47-vr",
    },
    KaunBanegaCrorepatiVR: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Kaun Banega Crorepati VR",
      name: "Kaun Banega Crorepati VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/kaunabanegacrorpativr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-kaun-banega-crorepati-vr",
    },
    safarisun: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Center Card VR",
      name: "Center Card VR",
      providerName: "Mac88 Gaming Virtual",
      imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
      redirectUrl: "/casino/aggapmac88gamingvirtual-center-card-vr",
    },
    // HiloVR: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "Hi Lo VR",
    //   name: "Hi Lo VR",
    //   providerName: "Mac88 Gaming Virtual",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo-vr",
    // },
    // AviatorX2: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "AviatorX2",
    //   name: "AviatorX2",
    //   providerName: "Mac88 Gaming Virtual",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-aviatorx2",
    // },
    // K3Lottery10: {
    //   code: "67690",
    //   casino: "aura",
    //   provider: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   alt: "K3 Lottery 10",
    //   name: "K3 Lottery 10",
    //   providerName: "Mac88 Gaming Virtual",
    //   imgUrl: "./images/alt-gaming/mac88/centrecard-vr.jpg",
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-k3-lottery-10",
    // },
  },
  relaxGaming: {
    holyhandgrenade: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Holy Hand Grenade",
      name: "Holy Hand Grenade",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/holyhandgrenade.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-holy-hand-grenade",
    },
    horrorhotel: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "5 Boys",
      name: "5 Boys",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/horrorhotel.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-horror-hotel",
    },
    hotrodracers: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hot Rod Racers",
      name: "Hot Rod Racers",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/hotrodracers.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-hot-rod-racers",
    },
    hurtresswildvegeance: {
      code: "92038",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Huntress Wild Vengeance",
      name: "Huntress Wild Vengeance",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/hurtresswildvegeance.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-huntress-wild-vengeance",
    },
    ironbank: {
      code: "67610",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Iron Bank",
      name: "Iron Bank",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/ironbank.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-iron-bank",
    },
    jokerspirit: {
      code: "67670",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Joker Split",
      name: "Joker Split",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/jokerspirit.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-joker-split",
    },
    lureoffortune: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lure of Fortune",
      name: "Lure of Fortune",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/lureoffortune.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-lure-of-fortune",
    },
    megaheist: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mega Heist",
      name: "Mega Heist",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/megaheist.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-mega-heist",
    },
    midnightmarauder: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Midnight Marauder",
      name: "Midnight Marauder",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/midnightmarauder.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-midnight-marauder",
    },
    moneycart3: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Cart 3",
      name: "Money Cart 3",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/moneycart3.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-money-cart-3",
    },
    moneycart4: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Cart 4",
      name: "Money Cart 4",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/moneycart4.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-money-cart",
    },
    moneytrain: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Train",
      name: "Money Train",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/moneytrain.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-money-train",
    },
    moneytrain3: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Train 3",
      name: "Money Train 3",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/moneytrain3.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-money-train-3",
    },
    moneytrain4: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Train 4",
      name: "Money Train 4",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/moneytrain4.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-money-train-4",
    },
    netgains: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Net Gains",
      name: "Net Gains",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/netgains.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-net-gains",
    },
    otterlyamazing: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Otterly Amazing",
      name: "Otterly Amazing",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/otterlyamazing.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-otterly-amazing",
    },
    pineofplinko2: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pine of Plinko 2",
      name: "Pine of Plinko 2",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/pineofplinko2.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-pine-of-plinko-2",
    },
    reapers: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Reapers",
      name: "Reapers",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/reapers.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-reapers",
    },
    royalpotato2: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Royal Potato 2",
      name: "Royal Potato 2",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/royalpotato2.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-royal-potato-2",
    },
    safarisun: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Safari Sun",
      name: "Safari Sun",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/safarisun.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-safari-sun",
    },
    sharkwash: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Shark Wash",
      name: "Shark Wash",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/sharkwash.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-shark-wash",
    },
    shinobispirit: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Shinobi Spirit",
      name: "Shinobi Spirit",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/shinobispirit.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-shinobi-spirit",
    },
    slothtumble: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sloth Tumble",
      name: "Sloth Tumble",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/slothtumble.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-sloth-tumble",
    },
    sweetopiaroyale: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Sloth Tumble",
      name: "Sloth Tumble",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/sweetopiaroyale.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-sweetopia-royale",
    },
    tarasque: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tarasque",
      name: "Tarasque",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/tarasque.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-tarasque",
    },
    templartumble: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Templar Tumble",
      name: "Templar Tumble",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/templartumble.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-templar-tumble",
    },
    titanstrike: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Titan Strike",
      name: "Titan Strike",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/titanstrike.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-titan-strike",
    },
    toriitumble: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Torii Tumble",
      name: "Torii Tumble",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/toriitumble.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-torii-tumble",
    },
    Wildchapo2: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Chapo 2",
      name: "Wild Chapo 2",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/Wildchapo2.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-wild-chapo-2",
    },
    WildHike: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Hike",
      name: "Wild Hike",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/WildHike.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-wild-hike",
    },
    WildYield: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Yield",
      name: "Wild Yield",
      providerName: "Relax Gaming",
      imgUrl: "./images/alt-gaming/relax-gaming/WildYield.jpg",
      redirectUrl: "/casino/aggaprelaxgaming-wild-yield",
    },
  },
  habaneroGaming: {
    arctichunt: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Arctic Hunt",
      name: "Arctic Hunt",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/arctichunt.jpg",
      redirectUrl: "/casino/aggaphabanero-arctic-hunt",
    },
    babayoga: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baba Yaga",
      name: "Baba Yaga",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/babayoga.jpg",
      redirectUrl: "/casino/aggaphabanero-baba-yaga",
    },
    baccarat: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/baccarat.jpg",
      redirectUrl: "/casino/aggaphabanero-baccarat",
    },
    baccartazerocommisiion: {
      code: "92038",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat Zero Commission",
      name: "Baccarat Zero Commission",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/baccartazerocommisiion.jpg",
      redirectUrl: "/casino/aggaphabanero-baccarat-zero-commission",
    },
    cranivalcove: {
      code: "67610",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Carnival Cove",
      name: "Carnival Cove",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/cranivalcove.jpg",
      redirectUrl: "/casino/aggaphabanero-carnival-cove",
    },
    doubleexposure3hand: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Double Exposure 3 Hand",
      name: "Double Exposure 3 Hand",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/doubleexposure3hand.jpg",
      redirectUrl: "/casino/aggaphabanero-double-exposure-3-hand",
    },
    dragontigergate: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon Tiger Gaet",
      name: "Dragon Tiger Gat",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/dragontigergate.jpg",
      redirectUrl: "/casino/aggaphabanero-dragon-tiger-gate",
    },
    gloryofrome: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Glory Of Rome",
      name: "Glory Of Rome",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/gloryofrome.jpg",
      redirectUrl: "/casino/aggaphabanero-glory-of-rome",
    },
    goldentajmahal: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Taj Mahal",
      name: "Golden Taj Mahal",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/goldentajmahal.jpg",
      redirectUrl: "/casino/aggaphabanero-golden-taj-mahal",
    },
    hauntedharbor: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Haunted Harbor",
      name: "Haunted Harbor",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/hauntedharbor.jpg",
      redirectUrl: "/casino/aggaphabanero-haunted-harbor",
    },
    hyperhues: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hyper Hues",
      name: "Hyper Hues",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/hyperhues.jpg",
      redirectUrl: "/casino/aggaphabanero-hyper-hues",
    },
    japanesemask: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Japanese Mask",
      name: "Japanese Mask",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/japanesemask.jpg",
      redirectUrl: "/casino/aggaphabanero-japanese-mask",
    },
    jump2: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jump! 2",
      name: "Jump! 2",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/jump!2.jpg",
      redirectUrl: "/casino/aggaphabanero-jump-2",
    },
    koikoitreasur: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Koi-Koi Treasure",
      name: "Koi-Koi Treasure",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/koikoitreasur.jpg",
      redirectUrl: "/casino/aggaphabanero-koi-koi-treasure",
    },
    laughingbuddha: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Laughing Buddha",
      name: "Laughing Buddha",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/laughingbuddha.jpg",
      redirectUrl: "/casino/aggaphabanero-laughing-buddha",
    },
    legendarybeats: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Legendary Beasts",
      name: "Legendary Beasts",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/legendarybeats.jpg",
      redirectUrl: "/casino/aggaphabanero-legendary-beasts",
    },
    moomoocow: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Moo Moo Cow",
      name: "Moo Moo Cow",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/moomoocow.jpg",
      redirectUrl: "/casino/aggaphabanero-moo-moo-cow",
    },
    naughtywukong: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Naughty Wukong",
      name: "Naughty Wukong",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/naughtywukong.jpg",
      redirectUrl: "/casino/aggaphabanero-naughty-wukong",
    },
    poseidon: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poseidon",
      name: "Poseidon",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/poseidon.jpg",
      redirectUrl: "/casino/aggaphabanero-poseidon",
    },
    rainbowmania: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rainbowmania",
      name: "Rainbowmania",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/rainbowmania.jpg",
      redirectUrl: "/casino/aggaphabanero-rainbowmania",
    },
    shamrockquest: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Shamrock Quest",
      name: "Shamrock Quest",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/shamrockquest.jpg",
      redirectUrl: "/casino/aggaphabanero-shamrock-quest",
    },
    sojubomb: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Soju Bomb",
      name: "Soju Bomb",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/sojubomb.jpg",
      redirectUrl: "/casino/aggaphabanero-soju-bomb",
    },
    spacegoonz: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Space Goonz",
      name: "Space Goonz",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/spacegoonz.jpg",
      redirectUrl: "/casino/aggaphabanero-space-goonz",
    },
    Superfruitblsst: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Fruit Blast",
      name: "Super Fruit Blast",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/Superfruitblsst.jpg",
      redirectUrl: "/casino/aggaphabanero-super-fruit-blast",
    },
    taikobeat: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Taiko Beats",
      name: "Taiko Beats",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/taikobeat.jpg",
      redirectUrl: "/casino/aggaphabanero-taiko-beats",
    },
    tensorbetter50hand: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tens or Better 50 Hand",
      name: "Tens or Better 50 Hand",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/tensorbetter50hand.jpg",
      redirectUrl: "/casino/aggaphabanero-tens-or-better-50-hand",
    },
    threecardpoker: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Three Card Poker",
      name: "Three Card Poker",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/threecardpoker.jpg",
      redirectUrl: "/casino/aggaphabanero-three-card-poker",
    },
    totemwarrior: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Totem Warrior",
      name: "Totem Warrior",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/totemwarrior.jpg",
      redirectUrl: "/casino/aggaphabanero-totem-warrior",
    },
    tuktukthailland: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Tuk Tuk Thailand",
      name: "Tuk Tuk Thailand",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/tuktukthailland.jpg",
      redirectUrl: "/casino/aggaphabanero-tuk-tuk-thailand",
    },
    waltzbeauty: {
      code: "67690",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Waltz Beauty",
      name: "Waltz Beauty",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/waltzbeauty.jpg",
      redirectUrl: "/casino/aggaphabanero-waltz-beauty",
    },
    war: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "War",
      name: "War",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/war.jpg",
      redirectUrl: "/casino/aggaphabanero-war",
    },
    wildflow: {
      code: "",
      casino: "",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Flow",
      name: "Wild Flow",
      providerName: "Habanero",
      imgUrl: "./images/alt-gaming/Habanero/wildflow.jpg",
      redirectUrl: "/casino/aggaphabanero-wild-flow",
    },
  },
};
